<ng-container *ngIf="currentPanel === 'main'">
    <web-widget-breadcrumbs [widget]="widget" [isInSpecificSection]="isSpecific"></web-widget-breadcrumbs>

    <div class="panel-options-body overflow-wrapper">
        <div class="form form-horizontal">
            <div class="form-group mb-0">
                <label class="col-xs-6">
                    {{ "control_menu_items" | translate }}
                </label>
                <div class="col-xs-6">
                    <a class="dotted pull-right" (click)="editMenuStyle()">{{ "control_menu_styles" | translate }}</a>
                </div>
            </div>
            <div class="mb-0" cdkDropList [cdkDropListData]="menuList" (cdkDropListDropped)="dropMenuItem($event)">
                <div
                    *ngFor="let menuItem of menuList.value; let i = index; trackBy: trackIndex"
                    cdkDrag
                    cdkDropListGroup
                    [cdkDragData]="menuItem"
                >
                    <sp-control-handle
                        [controlHandleBtn]="menuList.length === 1 ? false : true"
                        [controlHandleDisableDelete]="menuList.length === 1"
                        [controlHandleCheckbox]="true"
                        [controlHandleCheckboxChecked]="menuItem.isVisible"
                        [controlHandleMainText]="menuItem.name"
                        [controlHandleSubText]="menuItem.linkUrl"
                        [controlHandleDropdownActionList]="[
                            controlHandleEvents.copy,
                            controlHandleEvents.addSubMenu,
                            controlHandleEvents.delete,
                        ]"
                        (editActionEvent)="editMenuItem(menuItem, i)"
                        (copyActionEvent)="copyMenuItem(menuItem, i)"
                        (addSubMenuEvent)="addSubmenuItem(i)"
                        (removeActionEvent)="removeMenuItem(i)"
                        (toggleCheckBoxEvent)="changeMenuItemVisibility(i)"
                    >
                        <span cdkDragHandle></span>
                    </sp-control-handle>
                    <div
                        class="submenu-item-list"
                        [ngClass]="{ 'mb-15': menuItem.submenuList?.length }"
                        cdkDropList
                        [cdkDropListData]="menuItem.submenuList"
                        (cdkDropListDropped)="dropSubmenuItem($event, menuItem, i)"
                    >
                        <div
                            class="submenu-item"
                            *ngFor="let submenuItem of menuItem.submenuList; let i = index; trackBy: trackIndex"
                            cdkDrag
                            cdkDropListGroup
                            [cdkDragData]="submenuItem"
                        >
                            <sp-control-handle
                                [controlHandleBtn]="menuItem.submenuList.length === 1 ? false : true"
                                [controlHandleDisableDelete]="menuItem.submenuList.length === 1"
                                [controlHandleCheckbox]="true"
                                [controlHandleCheckboxChecked]="submenuItem.isVisible"
                                [controlHandleMainText]="submenuItem.name"
                                [controlHandleSubText]="submenuItem.linkUrl"
                                [controlHandleDropdownActionList]="[
                                    controlHandleEvents.copy,
                                    controlHandleEvents.delete,
                                ]"
                                (editActionEvent)="editSubmenuItem(menuItem, submenuItem, i)"
                                (copyActionEvent)="copySubmenuItem(menuItem, submenuItem, i)"
                                (removeActionEvent)="removeSubmenuItem(menuItem, i)"
                                (toggleCheckBoxEvent)="changeSubmenuItemVisibility(menuItem, submenuItem, i)"
                            >
                                <span cdkDragHandle></span>
                            </sp-control-handle>
                            <div class="item-dnd-placeholder" *cdkDragPlaceholder></div>
                        </div>
                    </div>
                    <div class="item-dnd-placeholder" *cdkDragPlaceholder></div>
                </div>

                <a class="dotted" (click)="addMenuItem()">{{ "add" | translate }}</a>
            </div>

            <div class="mt-20">
                <web-custom-id [displayId]="displayId" (valueChangeEvent)="updateWidgetDisplayId($event)">
                </web-custom-id>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="currentPanel === 'item-settings'">
    <web-navigation-settings
        [item]="editableMenuItem"
        (saveEvent)="saveMenuItem($event)"
        (cancelEvent)="cancelEditSettings()"
    ></web-navigation-settings>
</ng-container>

<ng-container *ngIf="currentPanel === 'submenu-item-settings'">
    <web-navigation-settings
        [item]="editableSubmenuItem"
        (saveEvent)="saveSubmenuItem($event)"
        (cancelEvent)="cancelEditSettings()"
    ></web-navigation-settings>
</ng-container>

<ng-container *ngIf="currentPanel === 'style-settings'">
    <web-style-settings [itemForm]="$any(data)" (cancelEvent)="cancelEditSettings()"></web-style-settings>
</ng-container>

<!--<ng-container *ngIf="currentPanel === 'logo-settings'">-->
<!--    <web-logo-settings-->
<!--        [item]="editableLogo"-->
<!--        (saveEvent)="saveLogoSettings($event)"-->
<!--        (cancelEvent)="cancelEditSettings()"-->
<!--    ></web-logo-settings>-->
<!--</ng-container>-->
